import { AttributeJoinCellComponent } from './customentity/attributejoin.cell.component';
import { ElementsPropertyRenderComponent } from './customform-editor/elementspropertyrender.component';
import { ElementsPropertyFieldComponent } from './customform-editor/elementspropertyfield.component';
import { GeometryEditorComponent } from './../components/geometry-editor/geometry-editor.component';
import { TypePropertyFieldListElementComponent } from './customentity/typepropertyfieldListElement.components';
import { IdPropertyComponent } from './customform-editor/idpropertyfield.component';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { UsuariosActionsCellComponent } from './usuarios/usuarios.actions.cell.component';
import { NgModule } from '@angular/core';
import { LightboxModule } from 'ngx-lightbox';
import { NbMenuModule, NbCardModule, NbActionsModule, NbIconModule, NbLayoutModule, NbInputModule,NbButtonModule,
  NbCheckboxModule,
  NbRadioModule,
  NbDatepickerModule,
  NbSelectModule,
  NbTabsetModule,
  NbSpinnerModule,
  NbAutocompleteModule,
  NbPopoverModule,
  NbTimepickerModule,
  NbListModule,} from '@nebular/theme';


import { ThemeModule } from '../@theme/theme.module';
import { PagesComponent } from './pages.component';
import { DashboardModule } from './dashboard/dashboard.module';
import { PagesRoutingModule } from './pages-routing.module';
import { CompaniesComponent } from './companies/companies.component';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { CompanyService } from '../apiclient';
import { UserSessionService } from '../UserSession/user-session.service';
import { CompaniesActionsCellComponent } from './companies/companies.actions.cell.component';
import { CompanyEditorComponent } from './company-editor/company-editor.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { FormsModule } from '@angular/forms';
import { FrameLinksComponent } from './frame-links/frame-links.component';
import { UserEditorComponent } from './user-editor/user-editor.component';
import { FrameLinksActionsCellComponent } from './frame-links/frame-links.actions.cell.component';
import { FrameLinkEditorComponent } from './frame-link-editor/frame-link-editor.component';
import { CustomformsComponent } from './customforms/customforms.component';
import { EntitiesimporterComponent } from './entitiesimporter/entitiesimporter.component';
import { CustomformEditorComponent } from './customform-editor/customform-editor.component';
import { CustomformsActionsCellComponent } from './customforms/customforms.actions.cell.component';
import { ExtraPropertyFieldEditorComponent } from './customform-editor/extrapropertyfield.component';
import { TypePropertyFieldComponent } from './customform-editor/typepropertyfield.component';
import { FramelinkViewerComponent } from './framelink-viewer/framelink-viewer.component';
import { VisorInformeMapaComponent } from './visor-informe-mapa/visor-informe-mapa.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { DiseaseLiteComponent } from './reports/disease-lite/disease-lite.component';
import { MaintenanceLiteComponent } from './reports/maintenance-lite/maintenance-lite.component';
import { SamplingLiteComponent } from './reports/sampling-lite/sampling-lite.component';
import { InformesComponent } from './informes/informes.component';
import { InformesActionsCellComponent } from './informes/informes.actions.cell.component';
import { DetalleInformeComponent } from './detalle-informe/detalle-informe.component';
import { NotebookLiteComponent } from './reports/notebook-lite/notebook-lite.component';
import { CompanyEntitiesListComponent } from './company-entities-list/company-entities-list.component';
import { FieldEditorComponent } from './field-editor/field-editor.component';
import { CustomentityComponent } from './customentity/customentity.component';
import { CustomElementActionsCellComponent } from './customentity/custom.element.actions.cell.component';
import { DependencyGroupComponent } from './customform-editor/dependencyGroup.component';
import { EventsComponent } from './customform-editor/events.component';
import { RelacionesEditorComponent } from './customentity/relaciones-editor/relaciones-editor.component';
import { CustomReportsImporterComponent } from './custom-reports-importer/custom-reports-importer.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';  //Esther EV2022-02

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { IconSelectorComponent } from './../components/icon-selector/icon-selector.component';


import { IconPropertyFieldComponent } from './company-editor/IconPropertyFieldComponent';  //Esther #146
import { IconPropertyRenderComponent } from './company-editor/IconPropertyRenderComponent';
import { ReportsInportConfirmationComponent } from './reports-inport-confirmation/reports-inport-confirmation.component';
import { CustomentitiesComponent } from './customentities/customentities.component';  //Esther #146
import { AttributeJoinViewcellComponent } from './customentity/attributejoin.viewcell.component';
import { HistoricoDialogComponent } from './customentity/historico-dialog/historico-dialog.component';
import { ElementsHistoryComponent } from './customentity/elements-history/elements-history.component';
import { ElementsDeletedComponent } from './customentity/elements-deleted/elements-deleted.component';
import { ElementsArchivedComponent } from './customentity/elements-archived/elements-archived.component';
import { HistoricDpendenciesCellComponent } from './customentity/historic.dependencies.cell.component';

import { AttributeTypeCellComponent } from './customentity/attributetypecell.components';
import { CustomEntityFieldComponent } from './reports/custom-entity-field/custom-entity-field.component';
import { CriteriosValidacionComponent } from './customform-editor/criteriosvalidacion.component';
import { VentanaModalComponent } from './customform-editor/ventanamodal.component';
import { ValorTraducidoComponent } from './customform-editor/valortraducido.component';
import { ValorTraducidoEventComponent } from './customform-editor/valortraducidoevent.component';
import { CustomformComponent } from './reports/customform/customform.component';
import { SubformComponent } from './reports/subform/subform.component';
import { DateFieldComponent } from './customentity/date-field/date-field.component';


/**
 * Módulo que aglutina todas las páginas de la app
 */
@NgModule({
  imports: [
    PagesRoutingModule,
    ThemeModule,
    NbMenuModule,
    DashboardModule,
    NbCardModule,
    NbLayoutModule,
    NbActionsModule,
    NbListModule,
    NbIconModule,
    NbInputModule,
    NbButtonModule,
    NbCheckboxModule,
    NbRadioModule,
    NbPopoverModule,
    NbDatepickerModule.forRoot(),
    NbTimepickerModule.forRoot(),
    NbDateFnsDateModule.forRoot({}),
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatMomentDateModule,
    NbSelectModule,
    FormsModule,
    NbTabsetModule,
    Ng2SmartTableModule,
    NbSpinnerModule,
    LightboxModule,
    NbAutocompleteModule,
    AngularMultiSelectModule,
    NgMultiSelectDropDownModule
  ],
  declarations: [
    PagesComponent,
    CompaniesComponent,
    CompaniesActionsCellComponent,
    UsuariosActionsCellComponent,
    FrameLinksActionsCellComponent,
    CustomformsActionsCellComponent,
    ExtraPropertyFieldEditorComponent,
    ElementsPropertyFieldComponent,
    ElementsPropertyRenderComponent,
    IdPropertyComponent,
    InformesActionsCellComponent,
    TypePropertyFieldComponent,
    CompanyEditorComponent,
    UsuariosComponent,
    FrameLinksComponent,
    UserEditorComponent,
    FrameLinkEditorComponent,
    CustomformsComponent,
    EntitiesimporterComponent,
    CustomformEditorComponent,
    FramelinkViewerComponent,
    VisorInformeMapaComponent,
    DiseaseLiteComponent,
    MaintenanceLiteComponent,
    SamplingLiteComponent,
    InformesComponent,
    DetalleInformeComponent,
    NotebookLiteComponent,
    CompanyEntitiesListComponent,
    FieldEditorComponent,
    CustomentityComponent,
    CustomElementActionsCellComponent,
    HistoricDpendenciesCellComponent,
    TypePropertyFieldListElementComponent,
    DependencyGroupComponent,
    EventsComponent,
    RelacionesEditorComponent,
    GeometryEditorComponent,
    CustomReportsImporterComponent,
    IconSelectorComponent,
    IconPropertyFieldComponent,
    IconPropertyRenderComponent,
    ReportsInportConfirmationComponent,
    CustomentitiesComponent,
    AttributeJoinCellComponent,
    AttributeJoinViewcellComponent,
    HistoricoDialogComponent,
    AttributeTypeCellComponent,
    ElementsHistoryComponent,
    ElementsDeletedComponent,
    ElementsArchivedComponent,
    CustomEntityFieldComponent,
    CriteriosValidacionComponent,
    VentanaModalComponent,
    ValorTraducidoComponent,
    ValorTraducidoEventComponent,
    CustomformComponent,
    SubformComponent,
    DateFieldComponent
  ],
  entryComponents: [CompaniesActionsCellComponent, UsuariosActionsCellComponent,FrameLinksActionsCellComponent,
    InformesActionsCellComponent,
    CustomformsActionsCellComponent,ExtraPropertyFieldEditorComponent,TypePropertyFieldComponent,
    AttributeJoinCellComponent,AttributeJoinViewcellComponent,AttributeTypeCellComponent,
    CustomElementActionsCellComponent,TypePropertyFieldListElementComponent,DependencyGroupComponent,EventsComponent,HistoricDpendenciesCellComponent],

})
export class PagesModule {
}
